import type { Channel, FaqItem } from "./types";

export const SITE = {
  brand: "瓜田雷达",
  brandEn: "RADAR",
  slogan: "提前一步，吃上最新鲜的瓜",
  intro:
    "瓜田雷达是一档专注娱乐圈八卦爆料与圈内资源情报的内容媒体。我们把散落在片场、品牌方、招商会和直播间周边的“饼”与“瓜”，整理成一条条可追溯、分等级的未官宣情报，帮你提前掌握谁在谈新戏、谁拿到综艺邀约、谁悄悄空降、谁的行程在路上。",
  established: "成立于 2023 年",
  coverNote:
    "本站内容均为网友投递或业内流传的信息，未经官方确认部分会明确标注“尚未官宣”，请理性看待、谨慎传播，一切以艺人及官方最终发布为准。",
  contactEmail: "tips@guatianradar.com",
};

export const channels: Channel[] = [
  {
    key: "schedule",
    name: "行程预警",
    tagline: "谁在动身、谁将空降，未官宣行程先看这里",
    icon: "ri-focus-3-line",
  },
  {
    key: "resource",
    name: "资源风云",
    tagline: "换角、压价、递本，圈内资源瓜一网打尽",
    icon: "ri-exchange-funds-line",
  },
  {
    key: "drama",
    name: "饼圈雷达",
    tagline: "新戏饼与拟邀阵容，影视项目动向早知道",
    icon: "ri-movie-2-line",
  },
  {
    key: "variety",
    name: "综艺动态",
    tagline: "音综、竞演与真人秀的邀约与阵容瓜",
    icon: "ri-mic-line",
  },
  {
    key: "brand",
    name: "代言风向",
    tagline: "高奢与快消的接触线索，商务代言风向标",
    icon: "ri-gemini-line",
  },
  {
    key: "pop",
    name: "空降情报",
    tagline: "直播间与线下快闪，空降活动的倒计时哨",
    icon: "ri-flashlight-line",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "瓜田雷达的八卦爆料准确吗？信息来源是什么？",
    a: "我们的大多数料源来自业内人士投稿、现场目击与公开物料交叉比对。凡未经当事人或官方确认的信息，我们都会明确标注“尚未官宣”并注明瓜源等级，方便你自行判断可信度，而不会把推测当成事实打包输出。",
  },
  {
    q: "“资源瓜”“新戏饼”“商务代言”这些词具体指什么？",
    a: "资源瓜指业内正在洽谈、尚未官宣的合作机会；新戏饼指流传中的影视项目与拟邀阵容；商务代言指品牌与艺人正在接触或已签约但未官宣的合作。它们都属于“未官宣范畴”的资源动态，也是本站最核心的追踪对象。",
  },
  {
    q: "为什么很多报道里不直接点名艺人？",
    a: "在信息尚未获得官方确认时直接点名，很容易对具体个人造成误伤。所以当瓜源存在不确定性，我们会先用“某顶流”“某85花”“某待爆男演员”这类代称，只有在信息可靠且多层互证后，才会逐步收束指向范围。",
  },
  {
    q: "如何向瓜田雷达投稿爆料？会被保密吗？",
    a: "你可以在栏目页底部或页脚的投稿入口提供线索，也可以通过我们公开的投稿邮箱发送图文。所有投稿我们都会做来源脱敏与隐私保护，先核查真实性、再决定是否发布，不会把未经确认的投稿当作既定事实。",
  },
  {
    q: "报道会不会侵犯艺人隐私或造成名誉问题？",
    a: "我们只讨论与公开工作相关的行程、项目和品牌动向，不涉及私人生活细节，并始终以“仅供参考”的克制口径呈现未证实信息。如果你或你所代表的艺人认为某条内容有误，欢迎联系我们申请核实与修正。",
  },
];

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "今日爆瓜", href: "#latest" },
  { label: "热度榜", href: "#hot" },
  { label: "深度档案", href: "#archive" },
  { label: "吃瓜指南", href: "#faq" },
  { label: "关于我们", href: "#about" },
];